import styled, { css } from "styled-components"
import { FontConfigurations, typography } from "theme"

import { RoundedBox } from "components/box"
import { ParagraphSmall } from "components/text"

export const INPUT_CSS = css`
  width: 100%;
  background-color: inherit;
  color: inherit;
`

export const Hint = styled(ParagraphSmall)`
  font-family: ${props => props.theme.fonts.paragraph};
  text-align: left;
  font-style: italic;
  color: ${props => props.theme.colors.evergreen};
`

export const Error = styled(ParagraphSmall).attrs({
  textAlign: "left",
  lineHeight: "normal",
  color: "salmon",
  mt: 1
})``

export const Box = styled(RoundedBox)<{
  disabled?: boolean
  active?: boolean
  error?: boolean
}>`
  position: relative;

  background-color: ${props => (props.disabled ? props.theme.colors.silver : props.theme.colors.white)};
  border: 1px solid;
  border-color: ${props => props.theme.colors.evergreen};
  color: ${props => props.theme.colors.evergreen};

  .input-component {
    padding: ${props => props.theme.space[4]};
  }

  /* Label is positioned as a placeholder initially */
  input + label {
    position: absolute;
    transform: translate(1rem, 0rem);

    color: inherit;
    transition: 0.2s;
  }

  input:placeholder-shown + label,
  input[id^="date"]::placeholder,
  input::placeholder,
  textarea::placeholder {
    color: ${props => (props.error ? props.theme.colors.salmon : props.theme.colors.silverDark)};
    pointer-events: none;
  }

  /* This transform is to imitate padding on the input */
  input:placeholder-shown + label {
    transform: translateX(${props => props.theme.space[4]});
  }

  /* Translate label to the top of the input box when focused */
  input:not(:placeholder-shown) + label {
    transform: translate(${props => props.theme.space[4]}, -${props => props.theme.space[4]});

    color: inherit;
    font-size: 10px;
  }

  /* Date input has different label and placeholder so positioning the label at the top */
  input[id^="date"] + label {
    position: absolute;
    transform: translate(${props => props.theme.space[4]}, -${props => props.theme.space[4]});

    font-size: 10px;
  }

  ${props =>
    props.error &&
    css`
      background-color: ${props.theme.colors.lightSalmon};
      border-color: ${props.theme.colors.salmon};
      color: ${props.theme.colors.salmon};
    `}
`

export const NumberInput = styled.input.attrs({
  ...FontConfigurations.p,
  type: "tel",
  pattern: "[0-9]*"
})`
  ${INPUT_CSS}
  ${typography}
`
